module.exports = __webpack_public_path__ + "b681db1dda00e6c9968d86ab7af6902d.glb";